import { GetStaticProps, InferGetStaticPropsType, NextPage } from 'next'
import { Text, Flex, Box, Button } from 'components/primitives'
import Layout from 'components/Layout'
import hunnysHeader from '/public/HunnysHalfBanner.png'
import hunnysHeart from '/public/hunnysHeart.svg'
import endorseGif from '/public/endorseGif.gif'
import endorsements1 from '/public/endorsements1.png'
import endorsements2 from '/public/endorsements2.png'
import collectionGif from '/public/hunnysCollectionGif.gif'
import { useTheme } from 'next-themes'
import { styled, globalCss, globalReset, darkTheme } from 'stitches.config';
import ThemeSwitcher from 'components/navbar/ThemeSwitcher'
import Image from 'next/image'
import { globalStyles } from 'stitches.config';
import { Luckiest_Guy } from '@next/font/google'
import { ComponentPropsWithoutRef, useContext, useState } from 'react'
import { ConnectWalletButton } from 'components/ConnectWalletButton'
import { Footer } from 'components/home/Footer'
import { useMediaQuery } from 'react-responsive'
import { useMarketplaceChain, useMounted } from 'hooks'
import { Card } from 'components/Card'
import { useAccount } from 'wagmi'
import { paths } from '@reservoir0x/reservoir-sdk'
import { useCollections } from '@reservoir0x/reservoir-kit-ui'
import fetcher from 'utils/fetcher'
import { NORMALIZE_ROYALTIES } from '../_app'
import supportedChains from 'utils/chains'
import Link from 'next/link'
import ChainToggle from 'components/common/ChainToggle'
import CollectionsTimeDropdown, {
  CollectionsSortingOption,
} from 'components/common/CollectionsTimeDropdown'
import { Head } from 'components/Head'
import { CollectionRankingsTable } from 'components/rankings/CollectionRankingsTable'
import { ChainContext } from 'context/ChainContextProvider'

type Props = InferGetStaticPropsType<typeof getStaticProps>

const List = styled('ul', {
  paddingLeft: '1em', // provide some space for custom bullet
  '& li': {
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: '-1em', // adjust as needed
      top: '0.5em', // adjust as needed
      width: '0.75em', // adjust as needed
      height: '0.75em', // adjust as needed
      background: `url("/hunnysHeart.svg") no-repeat`,
      backgroundSize: 'contain',
    },
  },
});

const luckiest_guy = Luckiest_Guy({
  subsets: ['latin'],
  weight: "400",
})

const AboutBlock = styled('div', {
  color: 'white',
  border: '3px solid #F4CC45',
  backgroundColor: '#5A1CDA',
  borderRadius: '5px',
  padding: '10px',
  marginBottom: '10px',
  '&:hover': {
    color: 'white',
    backgroundColor: '#9362F6',
  },
  '@dark': {
    backgroundColor: '$hunnysDarkPurple'
  }
})

const HunnysPage: NextPage<Props> = ({ ssr }) => {
  const isSSR = typeof window === 'undefined'
  const isMounted = useMounted()
  const compactToggleNames = useMediaQuery({ query: '(max-width: 800px)' })
  const [sortByTime, setSortByTime] =
    useState<CollectionsSortingOption>('1DayVolume')
  const marketplaceChain = useMarketplaceChain()
  const { isDisconnected } = useAccount()
  const card1Images = ["https://dl.openseauserdata.com/cache/originImage/files/a31f62eb044029c6c2f534a5a4ba4d9a.png", "https://dl.openseauserdata.com/cache/originImage/files/d92f3b38a8ceef123fd18fa4548d4517.png", "https://dl.openseauserdata.com/cache/originImage/files/99a9cdce6c45fbfdb6f95c93cae1d6ef.png", "https://dl.openseauserdata.com/cache/originImage/files/3f44fe1f936f81f431dc6f730447f199.png"];
  const card2Images = ["https://dl.openseauserdata.com/cache/originImage/files/a2a614ec8423da2a8c633e87ed7ce020.png", "https://dl.openseauserdata.com/cache/originImage/files/30f26e28f4632846e9bf24c4b825ab1a.png", "https://dl.openseauserdata.com/cache/originImage/files/6821fa106cc8e018123a92467ed41405.png", "https://dl.openseauserdata.com/cache/originImage/files/d2fd15cea3e6b087313b9f339dff0402.png", "https://dl.openseauserdata.com/cache/originImage/files/a60cd48181eaa7bb69e19ad771c13193.png"];
  const card3Images = ["https://dl.openseauserdata.com/cache/originImage/files/c0cd9148326df1c11fbadbfd3c366748.png", "https://dl.openseauserdata.com/cache/originImage/files/7427952a6e10ce6780dab1af7ccb85d0.png", "https://dl.openseauserdata.com/cache/originImage/files/d614ec60c986995f8a7e3b93860900e6.png", "https://dl.openseauserdata.com/cache/originImage/files/ff0e96fa3b1843c2daa3a4c2cc6f946c.png"];
  const card4Images = ["https://dl.openseauserdata.com/cache/originImage/files/5fdbd27bbd320a6d9025f2a5d85ae846.png", "https://dl.openseauserdata.com/cache/originImage/files/f8deafd3946cfa289e5369ec92018ff7.png", "https://dl.openseauserdata.com/cache/originImage/files/ffe9faef0676afb6cdcec96bd45c60e2.png", "https://dl.openseauserdata.com/cache/originImage/files/2670f86e2c141b1e988f110cb0a1a16c.png"];

  const { chain } = useContext(ChainContext)

  let volumeKey: ComponentPropsWithoutRef<
    typeof CollectionRankingsTable
  >['volumeKey'] = 'allTime'

  switch (sortByTime) {
    case '1DayVolume':
      volumeKey = '1day'
      break
    case '7DayVolume':
      volumeKey = '7day'
      break
    case '30DayVolume':
      volumeKey = '30day'
      break
  }

  return (
    <Layout>
      <Head />
      <Image
        alt={`Hunnys Banner`}
        src={hunnysHeader}
        style={{width:'100%'}}
      />
      <Box
        css={{
          background: '$hunnysPurple',
          p: 24,
          height: '100%',
          position: 'relative', // make sure it's relative
          '@bp800': {
            p: '$6',
          }
        }}
      >
      <Flex
        direction="column"
        align="center"
        css={{ mx: 'auto', maxWidth: 728, pt: '$5', textAlign: 'center' }}
      >
      <Text css={{
          fontFamily: "Luckiest Guy, cursive",
          fontSize: "4rem",
          fontWeight: 100,
          letterSpacing: "1px",
          textTransform: "uppercase",
        }}>
          Hunnys
        </Text>
        <Image
          alt={`Hunnys Gif`}
          src={collectionGif}
          width={200}
          style={{borderRadius:50}}
        />
        <Box css={{ alignSelf: 'center' }}>
          <Link href="/collection/ethereum/0x5dfeb75abae11b138a16583e03a2be17740eaded">
            <Button
              css={{
                minWidth: 224,
                marginTop: 50,
                justifyContent: 'center',
                fontFamily: "Luckiest Guy, cursive",
                background: '$btn2',
                color: '#5A1CDA',
                '&:hover': {
                  backgroundColor: '#F4CC45',
                },
                fontSize: "1.5rem",
                fontWeight: 100,
                letterSpacing: "1px",
                textTransform: "uppercase",
              }}
              size="large"
            >
              Shop Hunnys
            </Button>
          </Link>
        </Box>
        </Flex>
        {isDisconnected && (
          <Flex
            direction="column"
            align="center"
            css={{ mx: 'auto', maxWidth: 728, pt: '$5', textAlign: 'center' }}
          >
            <Text style="body1" css={{ mb: 48 }}>
            Connect your wallet to begin shopping, or to explore what you already own!
            </Text>
              <ConnectWalletButton />
          </Flex>
        )}
        <Flex css={{ my: '$6', gap: 65 }} direction="column">
        <Text css={{
            fontFamily: "Luckiest Guy, cursive",
            fontSize: "3rem",
            fontWeight: 100,
            letterSpacing: "1px",
            textTransform: "uppercase",
          }}>
        About
        </Text>
        <Flex
          justify="start"
          css={{
            flexDirection: 'column',
            marginRight: 'auto',
            gap: '10%',
            '@bp1400': {
              alignItems: 'left',
              flexDirection: 'row',
              margin: 12,
            },
          }}
        >
        <List css={{ textAlign: 'left', fontSize: 24, marginBottom:30}}>
            <li>Collect clothes, dyes and pets to customize your Hunny <span style={{fontSize:12}}>(Coming Soon)</span></li>
            <li>Revolutionary color harmony algorithm</li>
            <li>Over 1 million unique combinations</li>
            <li>9 unique trait categories & rarity system</li>
            <li>Free art airdrops every month</li>
            <li>Blockchain-based merch shop</li>
            <li>One of the earliest known NFTs created by a woman that represent women</li>
        </List>
        <iframe width="448px" height="252px" src="https://www.youtube.com/embed/HM7iJteTURA" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
</Flex>
        <Text css={{
            fontFamily: "Luckiest Guy, cursive",
            fontSize: "3rem",
            fontWeight: 100,
            letterSpacing: "1px",
            textTransform: "uppercase",
          }}>
        Benefits
        </Text>
        <List css={{ textAlign: 'left', fontSize: 24, marginBottom:30}}>
            <li>Monthly Art Airdrops</li>
            <li>Access to minting in the Hupe Scouts collection</li>
            <li>Exclusive Merchandise</li>
            <li>Creative Licensing</li>
            <li>And more!</li>
        </List>
        <Text css={{
            fontFamily: "Luckiest Guy, cursive",
            fontSize: "3rem",
            fontWeight: 100,
            letterSpacing: "1px",
            textTransform: "uppercase",
          }}>
                Stats
                </Text>
                <List css={{ textAlign: 'left', fontSize: 24, marginBottom:30}}>
                    <li>Launched in Sept. 2021</li>
                    <li>Ξ700 traded</li>
                    <li>Over 1 million unique combinations</li>
                    <li>9 unique trait categories & rarity system</li>
                    <li>Free art airdrops every month</li>
                    <li>Blockchain-based merch shop</li>
                    <li>One of the earliest known NFTs </li>
                </List>
<Text css={{
    fontFamily: "Luckiest Guy, cursive",
    fontSize: "3rem",
    fontWeight: 100,
    letterSpacing: "1px",
    textTransform: "uppercase",
  }}>
What suits you?
</Text>
<Flex
  justify="center"
  align="stretch"
  css={{
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 24,
      '@bp1100': {
        justifyContent: 'space-between',
      },
      '@bp800': {
        justifyContent: 'space-between',
      },
      '@bp500': {
        justifyContent: 'center',
      },
    }}
    >
  <Card
    headline="Cheer Squad"
    carouselImages={card1Images}
    button2Link="/collection/ethereum/0x5dfeb75abae11b138a16583e03a2be17740eaded?attributes%5BOutfit%5D=BunnyUCheerTop"
    button2Text="SHOP"
  />
  <Card
    headline="Friendly Pet Crew"
    carouselImages={card2Images}
    button2Link="/collection/ethereum/0x5dfeb75abae11b138a16583e03a2be17740eaded?attributes%5BHat%5D=CuteBird&attributes%5BHat%5D=BabyBunny&attributes%5BHat%5D=GhostKittyFriend&attributes%5BHat%5D=GhostCrocFriend&attributes%5BHat%5D=BooTheGhostFloop&attributes%5BHat%5D=HappyJohnathanTheFrog&attributes%5BHat%5D=BabyDragon&attributes%5BHat%5D=CuteOctopusHat"
    button2Text="SHOP"
  />
  <Card
    headline="Bikini Babes"
    carouselImages={card3Images}
    button2Link="/collection/ethereum/0x5dfeb75abae11b138a16583e03a2be17740eaded?attributes%5BOutfit%5D=StripedBikini"
    button2Text="SHOP"
  />
  <Card
    headline="Horny Hunnys"
    carouselImages={card4Images}
    button2Link="/collection/ethereum/0x5dfeb75abae11b138a16583e03a2be17740eaded?attributes%5BHat%5D=DevilHorns&attributes%5BHat%5D=DemonHorns"
    button2Text="SHOP"
  />
</Flex>
<Text css={{
    fontFamily: "Luckiest Guy, cursive",
    fontSize: "3rem",
    fontWeight: 100,
    letterSpacing: "1px",
    textTransform: "uppercase",
  }}>
More Information
</Text>
<script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
          <Flex
            justify="center"
            align="center"
            css={{
              flexDirection: 'column',
              marginRight: 'auto',
              gap: 12,
              '@bp1000': {
                alignItems: 'center',
                flexDirection: 'row',
                margin: 12,
              },
            }}
          >
            <Box css={{ width: 'calc(33.3%)', margin: '20px' }}>
              <div dangerouslySetInnerHTML={{__html: `          <blockquote class="twitter-tweet">              <p lang="en" dir="ltr">❤️ What is Hunnys? ❤️<br><br>Unleash your creativity with Hunnys - the revolutionary digital doll on the Ethereum blockchain.<br><br>Collect unique items, customize with over 1 million combinations, &amp; explore The Bunny Kingdom🐰💎<br><br>🧵👇 <a href="https://t.co/YSHwNAv4ll">pic.twitter.com/YSHwNAv4ll</a></p>
                  &mdash; Hunnys 💛 (@HunnysNFT) <a href="https://twitter.com/HunnysNFT/status/1621628406990356481?ref_src=twsrc%5Etfw">February 3, 2023</a>
                </blockquote>
              `}} />
            </Box>
            <Box css={{ width: 'calc(33.3%)', margin: '20px' }}>
              <div dangerouslySetInnerHTML={{__html: `          <blockquote class="twitter-tweet"><p lang="en" dir="ltr">On Aug. 23, we officially opened Bunny University ✏️<br><br>We wanted to give you some very quick context into...<br><br>📓What our first class was like<br>📓Why we started it<br>📓Where Bunny University is headed<br><br>Please turn the page 👇 <a href="https://t.co/g6xH8o34TP">pic.twitter.com/g6xH8o34TP</a></p>&mdash; Hunnys 💛 (@HunnysNFT) <a href="https://twitter.com/HunnysNFT/status/1562500554567618561?ref_src=twsrc%5Etfw">August 24, 2022</a></blockquote>
                </blockquote>
              `}} />
            </Box>
            <Box css={{ width: 'calc(33.3%)', margin: '20px' }}>
              <div dangerouslySetInnerHTML={{__html: `<blockquote class="twitter-tweet"><p lang="en" dir="ltr">⭐️Introducing... HUPE SCOUTS!⭐️<br><br>The Official Community-Owned Hunnys Derivative Brand!<br><br>Please take a look with us through this brand new initiative that the Hunnys team is launching today. We&#39;ll first introduce it, then include all need-to-know links &amp; info at the end💖 <a href="https://t.co/KzHPclNrJ1">pic.twitter.com/KzHPclNrJ1</a></p>&mdash; Hunnys 💛 (@HunnysNFT) <a href="https://twitter.com/HunnysNFT/status/1545468213085052929?ref_src=twsrc%5Etfw">July 8, 2022</a></blockquote>
              `}} />
            </Box>

          </Flex>
          <Box css={{ alignSelf: 'center' }}>
            <Link href="/collection/ethereum/0x5dfeb75abae11b138a16583e03a2be17740eaded">
            <Button
              css={{
                minWidth: 224,
                marginTop: 50,
                justifyContent: 'center',
                fontFamily: "Luckiest Guy, cursive",
                background: '$btn2',
                color: '#5A1CDA',
                '&:hover': {
                  backgroundColor: '#F4CC45',
                },
                fontSize: "1.5rem",
                fontWeight: 100,
                letterSpacing: "1px",
                textTransform: "uppercase",
              }}
              size="large"
            >
              Shop Hunnys
            </Button>
            </Link>
          </Box>
        </Flex>
        <Footer />
      </Box>
    </Layout>
  )
}


type CollectionSchema =
  paths['/collections/v5']['get']['responses']['200']['schema']
type ChainCollections = Record<string, CollectionSchema>

export const getStaticProps: GetStaticProps<{
  ssr: {
    collections: ChainCollections
  }
}> = async () => {
  let collectionQuery: paths['/collections/v5']['get']['parameters']['query'] =
    {
      sortBy: '1DayVolume',
      normalizeRoyalties: NORMALIZE_ROYALTIES,
      includeTopBid: true,
      limit: 10,
    }

  const promises: ReturnType<typeof fetcher>[] = []
  supportedChains.forEach((chain) => {
    const query = { ...collectionQuery }
    if (chain.collectionSetId) {
      query.collectionsSetId = chain.collectionSetId
    } else if (chain.community) {
      query.community = chain.community
    }
    promises.push(
      fetcher(`${chain.reservoirBaseUrl}/collections/v5`, query, {
        headers: {
          'x-api-key': chain.apiKey || '',
        },
      })
    )
  })
  const responses = await Promise.allSettled(promises)
  const collections: ChainCollections = {}
  responses.forEach((response, i) => {
    if (response.status === 'fulfilled') {
      collections[supportedChains[i].id] = response.value.data
    }
  })

  return {
    props: { ssr: { collections } },
    revalidate: 5,
  }
}

export default HunnysPage
